module.exports = __webpack_public_path__ + "assets/img/ic-bonus.769dfd21.svg";